<template>
  <div class="pg-input-number">
    <InputNumber
      :style="{ width: widthCover ? '100%' : 'auto' }"
      ref="PgInputNumber"
      v-bind="$attrs"
      :value="valueData"
      v-on="event"
      @input="onInput"
    ></InputNumber>
    <span class="unit" v-if="unit">{{ unit }}</span>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { InputNumber } from 'element-ui'
import { useListeners, computed, ref } from 'vue'

const props = defineProps({
  value: Number,
  unit: String,
  widthCover: Boolean,
})

const listeners = useListeners()
const event = computed(() =>
  Object.keys(listeners).reduce((pre, cur) => {
    if (cur !== 'input') pre[cur] = listeners[cur]
    return pre
  }, {})
)
const valueData = computed(() => {
  if (props.value === null) {
    return undefined
  } else {
    return props.value
  }
})

const emit = defineEmits('input', 'blur')
const onInput = (val) => {
  if (valueData.value !== val) {
    emit('input', val)
  }
}
const PgInputNumber = ref(null)

defineExpose({
  focus: () => {
    PgInputNumber.value.focus()
  },
})
</script>
<style lang="scss">
@import '../style/input-number.scss';
</style>
